export default {
    // A
    addToCalendar: 'Add to calendar',

    // C
    channelRooms: 'Channel rooms',
    createdBy: 'Created by',
    copyFailed: 'Could not copy the link.',
    copyLink: 'Copy link',

    // L
    linkCopied: 'Link copied',
    length: 'Length',

    // N
    next: 'Next',
    nextPage: 'Next page',
    noUpcomingRooms: 'No rooms yet. Pick an option above to record something.',
    noPastRooms: 'No past recordings.',
    notSet: 'Not set',

    // O
    open: 'Open',

    // P
    participants: '{n} participant | {n} participants',
    pagination: 'Room list pagination',
    previous: 'Previous',
    previousPage: 'Previous page',
    pageOf: 'Page {page} of {total}',

    // R
    ready: 'Recording ready',
    recording: 'Recording',

    // S
    submitVideo: 'Submit video',
    showingRange: '{from}–{to} of {total}',
    status: 'Status',

    // U
    unknown: 'Unknown',

    // V
    view: 'View recording',

    // W
    when: 'When',
    who: 'Who',
}
